module.exports = __webpack_public_path__ + "media/backgrounds/k-soma-plXL7vYXfyA-unsplash-27af97e4.jpg";